<script>
	export let stars = 0;
</script>
<style>
	.star {
		font-size: 1.1em;
	}
</style>

{#each [1, 2, 3, 4, 5] as i}
	<span class="star" style:color={(stars >= i)?'gold':'darkgray'}>&#x2605;</span>
{/each}
